// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.grid {
  padding: 20px;
}

.container {
  display: flex;
  gap: 2rem;
}
.graphcont {
  display: flex;
  justify-content: center;
  align-items: start;
}
.volume {
  border-radius: 11px;
  box-shadow: 10px 10px 23px #ececec, -10px -10px 23px #ffffff;
  padding: 12px 20px;
  min-width: 150px;
  display: flex;
  justify-content: center;
  flex-direction: column;
}
.box {
  height: max-content; /* Adjust height as needed */
}

.box1 {
  background: #fefefe;
  box-shadow: 10px 10px 23px #ececec, -10px -10px 23px #ffffff;
  padding: 20px 40px;
}

.box2 {
  border-radius: 18px;
  background: #fefefe;
  box-shadow: 10px 10px 23px #ececec, -10px -10px 23px #ffffff;
  padding: 2px 20px;
}

.parent-node {
  font-weight: 600 !important; /* Semibold */
  color: #141414; /* Primary color */
}

.child-node {
  font-weight: normal;
  color: #000000; /* Default text color */
}

.titlecontainer {
  display: flex;
  align-items: center !important;
  gap: 10px;
  justify-items: center !important;
  margin: 0;
  padding: 20px 0px;
}

@media (max-width: 768px) {
  .graphcont {
    flex-direction: column-reverse;
    align-items: center;
  }
  .grid {
    padding: 10px 20px; /* Decreased padding for mobile devices */
  }

  .box1 {
    padding: 10px 20px; /* Adjust padding for mobile devices */
  }

  .box2 {
    padding: 5px 10px; /* Adjust padding for mobile devices */
  }

  .titlecontainer {
    flex-direction: column;
    align-items: flex-start !important;
  }
}
@media (max-width: 768px) {
  .ant-row {
    flex-direction: column-reverse;
  }
}
`, "",{"version":3,"sources":["webpack://./src/page-components/SalesAndAnalytics/grid.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,SAAS;AACX;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,4DAA4D;EAC5D,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,sBAAsB;AACxB;AACA;EACE,mBAAmB,EAAE,4BAA4B;AACnD;;AAEA;EACE,mBAAmB;EACnB,4DAA4D;EAC5D,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,4DAA4D;EAC5D,iBAAiB;AACnB;;AAEA;EACE,2BAA2B,EAAE,aAAa;EAC1C,cAAc,EAAE,kBAAkB;AACpC;;AAEA;EACE,mBAAmB;EACnB,cAAc,EAAE,uBAAuB;AACzC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,gCAAgC;EAChC,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE;IACE,8BAA8B;IAC9B,mBAAmB;EACrB;EACA;IACE,kBAAkB,EAAE,yCAAyC;EAC/D;;EAEA;IACE,kBAAkB,EAAE,sCAAsC;EAC5D;;EAEA;IACE,iBAAiB,EAAE,sCAAsC;EAC3D;;EAEA;IACE,sBAAsB;IACtB,kCAAkC;EACpC;AACF;AACA;EACE;IACE,8BAA8B;EAChC;AACF","sourcesContent":[".grid {\n  padding: 20px;\n}\n\n.container {\n  display: flex;\n  gap: 2rem;\n}\n.graphcont {\n  display: flex;\n  justify-content: center;\n  align-items: start;\n}\n.volume {\n  border-radius: 11px;\n  box-shadow: 10px 10px 23px #ececec, -10px -10px 23px #ffffff;\n  padding: 12px 20px;\n  min-width: 150px;\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n}\n.box {\n  height: max-content; /* Adjust height as needed */\n}\n\n.box1 {\n  background: #fefefe;\n  box-shadow: 10px 10px 23px #ececec, -10px -10px 23px #ffffff;\n  padding: 20px 40px;\n}\n\n.box2 {\n  border-radius: 18px;\n  background: #fefefe;\n  box-shadow: 10px 10px 23px #ececec, -10px -10px 23px #ffffff;\n  padding: 2px 20px;\n}\n\n.parent-node {\n  font-weight: 600 !important; /* Semibold */\n  color: #141414; /* Primary color */\n}\n\n.child-node {\n  font-weight: normal;\n  color: #000000; /* Default text color */\n}\n\n.titlecontainer {\n  display: flex;\n  align-items: center !important;\n  gap: 10px;\n  justify-items: center !important;\n  margin: 0;\n  padding: 20px 0px;\n}\n\n@media (max-width: 768px) {\n  .graphcont {\n    flex-direction: column-reverse;\n    align-items: center;\n  }\n  .grid {\n    padding: 10px 20px; /* Decreased padding for mobile devices */\n  }\n\n  .box1 {\n    padding: 10px 20px; /* Adjust padding for mobile devices */\n  }\n\n  .box2 {\n    padding: 5px 10px; /* Adjust padding for mobile devices */\n  }\n\n  .titlecontainer {\n    flex-direction: column;\n    align-items: flex-start !important;\n  }\n}\n@media (max-width: 768px) {\n  .ant-row {\n    flex-direction: column-reverse;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
